<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Admin Dashboard</h2>
        </header>
  
        <main class="p-6 flex-1">
          <div class="grid grid-cols-3 gap-6">
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Users</h3>
              <p class="text-gray-300 mt-2">Total: <span class="text-blue-400">{{ dashboard.totalUsers }}</span></p>
              <p class="text-gray-300">Active: <span class="text-green-400">{{ dashboard.activeUsers }}</span></p>
            </div>
  
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Affiliates</h3>
              <p class="text-gray-300 mt-2">Referrals: <span class="text-blue-400">{{ dashboard.totalReferrals }}</span></p>
              <p class="text-gray-300">Earnings: <span class="text-green-400">${{ dashboard.totalEarnings }}</span></p>
            </div>
  
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Cloud Servers</h3>
              <p class="text-gray-300 mt-2">Total: <span class="text-blue-400">{{ dashboard.totalServers }}</span></p>
              <p class="text-gray-300">Running: <span class="text-green-400">{{ dashboard.activeServers }}</span></p>
            </div>
          </div>
  
          <div class="mt-6 bg-gray-800 p-6 rounded-xl shadow-md">
            <h3 class="text-lg font-semibold mb-4">Recent Signups</h3>
            <table class="w-full text-gray-300">
              <thead>
                <tr class="border-b border-gray-600">
                  <th class="py-2 text-left">User</th>
                  <th class="py-2 text-left">Signup Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in dashboard.recentUsers" :key="user.id" class="border-b border-gray-700">
                  <td class="py-2">{{ user.name }}</td>
                  <td class="py-2">{{ formatDate(user.date) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import Navbar from "@/components/adminnav.vue";

  export default {
    name: "AdminDashboard",
    data() {
      return {
        dashboard: {
          totalUsers: 0,
          activeUsers: 0,
          totalReferrals: 0,
          totalEarnings: 0,
          totalServers: 0,
          activeServers: 0,
          recentUsers: []
        }
      };
    },
    mounted() {
      this.fetchDashboardData();
    },
    methods: {
      async fetchDashboardData() {
        try {
          const response = await axios.get("https://api.syniac.com:3000/api/admin/dashboard/dashboard", { withCredentials: true });
          this.dashboard = response.data;
        } catch (error) {
          console.error("Error fetching dashboard data:", error);
        }
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString("en-US");
      }
    },
    components: {
        Navbar
    }
  };
  </script>
  
